import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./ClientDashboardDemoComponents.module.scss";

function AlarmErrorWidgetDemo({ buildingId }) {
  const [alarmRows, setAlarmRows] = useState([]);

  useEffect(() => {
    const fetchAlarmData = async () => {
      try {
        const response = await axios.get(
          `/batteries/getBatteryTableDataClient?buildingId=${buildingId}`
        );

        if (response.status === 200) {
          const objects = {};
          for (const item of response.data) {
            objects[item.tag] = item.value;
          }

          let alarmMessage = objects["alarmMessage"];

          if (!alarmMessage || alarmMessage.trim() === "" || alarmMessage === "{}") {
            // Handle empty cases
            setAlarmRows([{ time: "N/A", message: "No Error" }]);
          } else {
            try {
              const parsed = JSON.parse(alarmMessage);

              if (
                parsed &&
                typeof parsed === "object" &&
                Object.keys(parsed).length > 0
              ) {
                // Convert JSON into an array for rendering
                const rows = Object.entries(parsed).map(([time, message]) => ({
                  time,
                  message,
                }));
                setAlarmRows(rows);
              } else {
                setAlarmRows([{ time: "N/A", message: "No Error" }]);
              }
            } catch (err) {
              setAlarmRows([{ time: "N/A", message: alarmMessage }]);
            }
          }
        }
      } catch (err) {
        console.error("Error fetching alarm data", err);
        setAlarmRows([{ time: "N/A", message: "Error loading alarms" }]);
      }
    };

    if (buildingId) {
      fetchAlarmData();
    }
  }, [buildingId]);

  return (
    <div className={styles.AlarmWidgetLayoutContainer}>
      <div style={{ width: "100%" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            background: "var(--table-bg)",
            color: "var(--text-high, rgba(255,255,255,0.87))",
            border: "1px solid var(--table-border)",
            fontSize: "0.95rem",
          }}
        >
          <thead>
            <tr style={{ background: "#000", color: "#fff" }}>
              <th
                style={{
                  textAlign: "left",
                  padding: "8px",
                  borderBottom: "1px solid var(--table-border)",
                }}
              >
                Time
              </th>
              <th
                style={{
                  textAlign: "left",
                  padding: "8px",
                  borderBottom: "1px solid var(--table-border)",
                }}
              >
                Message
              </th>
            </tr>
          </thead>
          <tbody>
            {alarmRows.map((row, idx) => (
              <tr
                key={idx}
                style={{
                  borderBottom: "1px solid var(--table-border)",
                  color: "var(--text-high, rgba(255,255,255,0.87))",
                }}
              >
                <td style={{ padding: "8px" }}>{row.time}</td>
                <td style={{ padding: "8px" }}>{row.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AlarmErrorWidgetDemo;
